__turbopack_context__.v({
  "accent": "ServerSupportShowcaseSection-module__kJjWbG__accent",
  "block": "ServerSupportShowcaseSection-module__kJjWbG__block",
  "contentInner": "ServerSupportShowcaseSection-module__kJjWbG__contentInner",
  "contentSide": "ServerSupportShowcaseSection-module__kJjWbG__contentSide",
  "description": "ServerSupportShowcaseSection-module__kJjWbG__description",
  "eyebrow": "ServerSupportShowcaseSection-module__kJjWbG__eyebrow",
  "imageOverlay": "ServerSupportShowcaseSection-module__kJjWbG__imageOverlay",
  "imageSide": "ServerSupportShowcaseSection-module__kJjWbG__imageSide",
  "rowReverse": "ServerSupportShowcaseSection-module__kJjWbG__rowReverse",
  "section": "ServerSupportShowcaseSection-module__kJjWbG__section",
  "side": "ServerSupportShowcaseSection-module__kJjWbG__side",
  "title": "ServerSupportShowcaseSection-module__kJjWbG__title",
});
